import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    totalCount: 0,
    pendingCount: 0,
    loading: false,
    error: null
};

export const pickupRequestsSlice = createSlice({
    name: 'pickupRequests',
    initialState,
    reducers: {
        setPickupCount: (state, action) => {
            state.totalCount = action.payload;
        },
        setPendingPickupCount: (state, action) => {
            state.pendingCount = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        resetPickupState: (state) => {
            state.totalCount = 0;
            state.pendingCount = 0;
            state.loading = false;
            state.error = null;
        }
    }
});

export const { setPickupCount, setPendingPickupCount, setLoading, setError, resetPickupState } = pickupRequestsSlice.actions;

export default pickupRequestsSlice.reducer;